import { CSSProperties } from 'react';
export const paymentActionStyle: CSSProperties = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  background: '#4A7EB522', border: '1px solid #4A7EB544', color: '#4A7EB5',
  borderRadius: 8, padding: '7px 12px', fontSize: 12, fontWeight: 600,
  lineHeight: '18px', textDecoration: 'none', whiteSpace: 'nowrap', cursor: 'pointer',
};
export const paymentDeleteStyle: CSSProperties = { ...paymentActionStyle, background: '#EF444422', borderColor: '#EF444444', color: '#EF4444' };
